import { ITradingBlockApi, OrderGetOrder } from '@tradingblock/api';
import { Config } from '../config';

type OrderAccountClient = Awaited<ReturnType<ITradingBlockApi['order']>>;

export function fetchAccountOrders(
  client: Pick<OrderAccountClient, 'get' | 'search'>,
  request: OrderGetOrder
): ReturnType<OrderAccountClient['get']> {
  return Config.useOrdersSearchEndpoint ? client.search(request) : client.get(request);
}
